var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { staticClass: "preview" },
        [
          _c("el-button", {
            staticClass: "closeBtn",
            attrs: { icon: "el-icon-circle-close" },
            on: { click: _vm.closePre },
          }),
          _c(
            "div",
            {
              staticClass: "flex",
              staticStyle: {
                height: "100%",
                width: "100%",
                "justify-content": "space-around",
              },
            },
            [
              _vm.list.length > 0
                ? _c(
                    "div",
                    { staticClass: "arrowBox flex" },
                    [
                      _c("el-button", {
                        staticClass: "arrowBtn",
                        attrs: { circle: "", icon: "el-icon-arrow-left" },
                        on: { click: _vm.prev },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isVideo
                ? [
                    _vm.list.length > 0
                      ? _c("div", { staticClass: "img-box" }, [
                          _c("img", { attrs: { src: _vm.imgUrl } }),
                        ])
                      : _c("div", { staticClass: "info-box flex" }, [
                          _vm._v(" " + _vm._s(_vm.info) + " "),
                        ]),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "player-box" },
                      [
                        _c("video-player", {
                          ref: "videoPlayer",
                          staticClass: "video-player vjs-custom-skin video-box",
                          attrs: {
                            playsinline: true,
                            options: _vm.playerOptions,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
              _vm.name
                ? _c("div", { staticClass: "title-box" }, [
                    _vm._v(_vm._s(_vm.name)),
                  ])
                : _vm._e(),
              _vm.list.length > 0
                ? _c(
                    "div",
                    { staticClass: "arrowBox flex" },
                    [
                      _c("el-button", {
                        staticClass: "arrowBtn",
                        attrs: { circle: "", icon: "el-icon-arrow-right" },
                        on: { click: _vm.next },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }